// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610012013/js/" + chunkId + "." + {"44":"31d54303","225":"10492158","481":"4ada2ed4","486":"e6622515","770":"71cca594"}[chunkId] + ".0.9284010316816119.chunk.js";
};